import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    description:
      'Validate the requests from your employees and keep control of your budget, even as a team.',
    loadMore: 'Load more',
    title: 'Requests',
  },
  fr: {
    description:
      'Validez les demandes de vos employé·es et gardez la main sur votre budget, même en équipe.',
    loadMore: 'Charger plus',
    title: 'Demandes',
  },
} as const);

export default locales;
